import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

import ViewOnPath from '../../image/ViewOn.png';
import ViewOffPath from '../../image/ViewOff.png';
import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const SignUpPwInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn } = props;
	const { t } = useLanguage();
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [clickView, setClickView] = useState(true);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);
	const [isInvalidPw, setIsInvalidPw] = useState(false);

	const BorderRef = useRef();
	const inputRef = useRef();
	const ViewButtonRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			BorderRef.current.style.borderColor = theme.pointRed;
			inputRef.current.style.borderColor = theme.pointRed;
			ViewButtonRef.current.style.borderColor = theme.pointRed;
		},
		isValidPassword: () => {
			const pw = value;

			if (pw === '') {
			setIsInvalidPw(true);
			setDefaultPlaceholder(t('signUp.pwRequired'));
			BorderRef.current.style.borderColor = theme.pointRed;
			return false;
			}

			if (!isValidPassword(pw)) {
			setIsInvalidPw(true);
			setDefaultPlaceholder(t('signUp.pwFormatError'));
			BorderRef.current.style.borderColor = theme.pointRed;
			return false;
			}

			setIsInvalidPw(false);
			return true;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			BorderRef.current.style.borderColor = theme.line;
			inputRef.current.style.borderColor = theme.line;
			ViewButtonRef.current.style.borderColor = theme.line;
		} 
	}));

	useEffect(() => {
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	function handleClick(e) {
		BorderRef.current.style.borderColor = theme.pointRed;
		inputRef.current.style.borderColor = theme.primary;
		ViewButtonRef.current.style.borderColor = theme.primary;
		setDefaultPlaceholder('');
	}

	function handleChange(e) {
		const val = e.target.value;
		setValue(val);
		setChanged(true);

		if (val === '') {
			setIsInvalidPw(false);
			return;
		}

		if (!isValidPassword(val)) {
			setIsInvalidPw(true);
			BorderRef.current.style.borderColor = theme.pointRed;
			ViewButtonRef.current.style.borderColor = theme.pointRed;
		}
		else {
			setIsInvalidPw(false);
			BorderRef.current.style.borderColor = theme.line;
			ViewButtonRef.current.style.borderColor = theme.line;
		}
	}

	function handleFocus(e) {
		if (changed) {
			// do nothing
		}
		else {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);

		if (!isInvalidPw && isValidPassword(value)) {
			BorderRef.current.style.borderColor = theme.line; // 정상 회색
			ViewButtonRef.current.style.borderColor = theme.line;
		}
	}

	function isValidPassword(pw) {
		if (pw.length < 6) return false;
		if (!/[A-Za-z]/.test(pw)) return false;      // 영문
		if (!/[0-9]/.test(pw)) return false;         // 숫자
		if (!/[!@#$%^&*(),.?":{}|<>]/.test(pw)) return false; // 특수문자
		return true;
	}

	return (
		<TopLevelWrapper ref={BorderRef}>
			<Input
				ref={inputRef}
				clickCount={clickCount}
				type={clickView ? 'password' : 'text'}
				placeholder={defaultPlaceholder}
				value={value}
				className={`${className} ${changed ? "changed" : ""}`}
				onClick={handleClick}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur} />
			<ViewButtonWrapper ref={ViewButtonRef} onClick={() => (clickView ? setClickView(false) : setClickView(true))}>
				<ViewIcon src={clickView ? ViewOnPath : ViewOffPath}/>
				<ViewButton clickView={clickView}>{clickView ? t('signUp.showPassword') : t('signUp.hidePassword')}</ViewButton>
			</ViewButtonWrapper>
		</TopLevelWrapper>
	)
});

export default SignUpPwInput;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: space-between;
	align-items: flex-end;

	width: 100%;
	
	border-bottom: 1px solid ${props => props.theme.line};

  transition: all 0.5s ease-in-out;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	padding: 0 0 4px 0;
	margin-top: 10px;
	// margin-top: max(12px, 0.8333333333333333vw);

	// width: 72%;
	// width: max(157px, 18.90625vw);
	flex: 1;
	min-width: 0;
	// background-color: blue;
	outline: none;
	border: 0px;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	// color: #000000;

	background-color: ${props => props.theme.subBackground};

	color: ${props => props.theme.text};

	::placeholder {
		color: ${props => props.clickCount < 1 || props.value !== '' ? props.theme.line : props.theme.pointRed};
	}
	
  transition: all 0.5s ease-in-out;
`;

const ViewButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: flex-start;
	align-items: center;

	flex-shrink: 0;

	// width: 200px;
	// background-color: red;
	// width: max(93px, 5.46875vw);
	// height: 76%;105
	
	// border: solid;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
  // transition: all 0.5s ease-in-out;
	overflow: hidden;

	@media (hover: hover) {
		&:hover {
			cursor: pointer;
		}
	}
`;

const ViewIcon = styled.img`
	width: 20px;
	height: 20px;

	margin: 0 4px 4px 0;
`;

const ViewButton = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;

	margin: 0 0 4px 0;

	color: ${props => props.theme.primary};

	white-space: nowrap;
`;